module.exports = __webpack_public_path__ + "media/soundtrack.83523c69.mp3";